var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMobileQuestion = function SvgMobileQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73189 6.90621C3.73101 6.27615 3.85484 5.65215 4.09625 5.07018C4.33766 4.4882 4.69186 3.95976 5.13845 3.51532C5.58504 3.07087 6.11518 2.71921 6.69831 2.48061C7.28144 2.24201 7.90603 2.12118 8.53608 2.12509C11.1651 2.14464 13.268 4.32987 13.268 6.96623V7.43746C13.268 9.81584 13.7656 11.196 14.2038 11.9503C14.251 12.0309 14.2761 12.1225 14.2766 12.2159C14.2771 12.3093 14.253 12.4012 14.2067 12.4823C14.1603 12.5634 14.0934 12.6309 14.0127 12.6779C13.9319 12.7249 13.8402 12.7497 13.7468 12.75H3.25248C3.15906 12.7497 3.06735 12.7248 2.98662 12.6778C2.90588 12.6308 2.83896 12.5634 2.79262 12.4823C2.74628 12.4012 2.72215 12.3093 2.72266 12.2158C2.72318 12.1224 2.74832 12.0308 2.79556 11.9502C3.23406 11.1958 3.73189 9.81572 3.73189 7.43746L3.73189 6.90621Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 12.75V13.2812C6.375 13.8448 6.59888 14.3853 6.9974 14.7839C7.39591 15.1824 7.93641 15.4062 8.5 15.4062C9.06359 15.4062 9.60409 15.1824 10.0026 14.7839C10.4011 14.3853 10.625 13.8448 10.625 13.2812V12.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileQuestion.62e67016.svg";
export { ForwardRef as ReactComponent };